/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function() {

    function promotionalSlider() {
        let promotionalWrapper = document.querySelectorAll('.promotional-banner__wrapper');
  
        promotionalWrapper.forEach(wrapper => {
        let id = wrapper.getAttribute('data-section-id');
        let swiperContainer = document.querySelector('#promo-products-' + id);
        if (swiperContainer) {
            if (swiperContainer.swiper) {
            swiperContainer.swiper.destroy();
            }
    
            let swiperOptions = {
                slidesPerView: 1.1,
                spaceBetween: 10,
                speed: 1000,
                navigation: {
                    nextEl: ".swiper-button-next.swiper-button-" + id,
                    prevEl: ".swiper-button-prev.swiper-button-" + id,
                },
                pagination: {
                    el: ".swiper-pagination-" + id + ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    641: {
                        slidesPerView: 2,
                        spaceBetween: 22,
                    },
                },
            };
            let swiper = new Swiper('#promo-products-' + id, swiperOptions);
        }
        });
    }

    function productDetailTabs() {
        const tabButtons = document.querySelectorAll(".product-details__tab--item"); 
        const tabContainers = document.querySelectorAll(".product-details__tab--block");

        const readMoreBtn = document.querySelectorAll('.product-desc__more--btn');
        const readLessBtn = document.querySelectorAll('.product-desc__less--btn');
        const productDescriptionContainer = document.querySelector('.product-decsription__content');

        tabButtons.forEach(button => {
            if (button) {
                button.addEventListener("click", function () {
                    const targetTab = this.getAttribute("data-tab-block");
    
                    tabButtons.forEach(btn => btn.classList.remove("active"));
                    this.classList.add("active");
    
                    tabContainers.forEach(container => container.classList.remove("active"));
    
                    const targetContainer = document.querySelector(`.product-details__tab--block[data-tab-block="${targetTab}"]`);
                    if (targetContainer) {
                        targetContainer.classList.add("active");
                    } else {
                        console.warn(`Tab content for data-tab-block="${targetTab}" not found.`);
                    }
                });
            }
            
        });

        readMoreBtn.forEach(btn => {
            if (btn) {
                btn.addEventListener('click', () => {
                    if (productDescriptionContainer) {
                        productDescriptionContainer.classList.add('expanded');
                    }
                    btn.classList.add('hidden');
                    readLessBtn.forEach(btn => btn.classList.remove('hidden'));
                });
            }
        });
        readLessBtn.forEach(btn => {
            if (btn) {
                btn.addEventListener('click', () => {
                    if (productDescriptionContainer) {
                        productDescriptionContainer.classList.remove('expanded');
                    }
                    btn.classList.add('hidden');
                    readMoreBtn.forEach(btn => btn.classList.remove('hidden'));
                });
            }
        });
    } 

    function categoryLinks() {
        let links = document.querySelectorAll(".blog-sidebar__text p");
    
        if (links.length === 0) return;
    
        let currentURL = window.location.pathname;
        let activeLink = null;
    
        links.forEach(link => link.classList.remove("active"));
        links[0].classList.add("active");
    
        links.forEach(link => {
            let anchor = link.querySelector("a");
            if (anchor) {
                let linkHref = new URL(anchor.href, window.location.origin).pathname;
                if (linkHref === currentURL) {
                    activeLink = link;
                }
            }
        });
    
        if (activeLink) {
            links.forEach(link => link.classList.remove("active"));
            activeLink.classList.add("active");
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        promotionalSlider();
        productDetailTabs();
        categoryLinks();
    });
})();

